window.String.prototype.toCamel = function () {
    return this.replace(/(\-[a-z])/g, function ($1) {
        return $1.toUpperCase().replace('-', '');
    });
};

window.String.prototype.toKebab = function () {
    return this.replace(/([A-Z])/g, function ($1) {
        return '-' + $1;
    }).toLowerCase();
};

window.String.prototype.toSnake = function () {
    return this.replace(/([A-Z])/g, function ($1) {
        return '_' + $1;
    }).toLowerCase();
};
